import createBaseActions from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import { gwGet } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';

const { SET_CHECK_IP_RESULT, FETCH_COUNTRY_WHITELIST_SUCCESS } = actionTypes;

export const setCheckIpResult = createBaseActions(SET_CHECK_IP_RESULT, 'data');
export const setCountryWhitelist = createBaseActions(FETCH_COUNTRY_WHITELIST_SUCCESS, 'data');

export const fetchCountryWhitelist = () => async (dispatch) => {
  try {
    const result = await gwGet(API_PATH.GET_COUNTRY_WHITELIST);
    if (result.success) {
      dispatch(setCountryWhitelist(result.data));
    }
  } catch (error) {
    throw error;
  }
};

export default {};
